import {
  prismicAPIEndpoint,
  prismicAccessToken,
} from '@lyfta/components-config'
import Prismic from '@prismicio/client'

export const PrismicClient = Prismic.client(prismicAPIEndpoint, {
  accessToken: prismicAccessToken,
})
